import { Grid, makeStyles, Theme } from "@material-ui/core";
import React, { useEffect } from "react";
import { ScopeApplication } from "../../domain/ScopeApplication";
import { SectionProps } from "./SectionProps";
import { Error } from "../common/Error";
import { ScopesList } from "../scopes/ScopesList";
import { useDispatch, useSelector } from "react-redux";
import { itemSelector } from "../../redux/selectors";
import { ScopeApplicationState } from "../../domain/ScopeApplication";
import { Scope } from "../../domain/Scope";
import {
  addScope,
  deleteSelectedScopes,
  toggleDeleteScope,
  updateScope,
} from "../../redux/actions";
import { LookupTrackerStore } from "@ofqual/portal-core/core/types";
import { useOrganisationScopesState } from "../../hooks/useOrganisationScopesState";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => {
  return {
    formHeading: {
      color: "#9f9f9f",
      fontSize: "1em",
      marginBottom: "30px",
      fontWeight: 600,
      position: "relative",
    },
  };
});

export const QuestionOne: React.FC<SectionProps<ScopeApplication>> = ({
  errors,
  disabled,
  clearErrors,
  isAdmin,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { itemId } = useParams<{ itemId: string }>();

  const { scopes, item } = useSelector(itemSelector);
  const orgScopesState = useOrganisationScopesState(itemId);

  useEffect(() => {
    if (scopes.length) {
      clearErrors("scopes");
    }
  }, [scopes, clearErrors]);

  const onToggleDeleteScopes = (scopes: Scope[]) =>
    dispatch(toggleDeleteScope(scopes));

  const onDeleteScopes = () => dispatch(deleteSelectedScopes());

  const onAddScope = (scope: Scope) => {
    dispatch(addScope(scope));
  };

  const onUpdateScope = (
    scope: Scope,
    lookupTrackingInfo: LookupTrackerStore
  ) => {
    dispatch(updateScope(scope, lookupTrackingInfo));
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <h6
          className={classes.formHeading}
          style={{ marginTop: "8px", marginBottom: "8px" }}
          data-test="scopes-heading"
        >
          List of scopes applied for
        </h6>
        <ScopesList
          canEdit={!disabled}
          scopes={scopes}
          canApprove={
            isAdmin && item?.state === ScopeApplicationState.Submitted
          }
          actions={{
            onToggleDeleteScopes,
            onAddScope,
            onDeleteScopes,
            onUpdateScope,
          }}
          existingScopes={orgScopesState?.scopes!}
        />
        {errors.scopes && errors.scopes.message && (
          <Error>{errors.scopes.message}</Error>
        )}
      </Grid>
    </Grid>
  );
};
